/**
 * Theme-aware full logo component for hero sections and branding
 */
import React from 'react';
import { useTheme } from '@/app/providers/ThemeProvider';
import CodiiLogoFullDark from '@/assets/codii-logo-full-dark.svg';
import CodiiLogoFullLight from '@/assets/codii-logo-full-light.svg';

interface ThemeAwareFullLogoProps {
  className?: string;
  alt?: string;
}

const ThemeAwareFullLogo: React.FC<ThemeAwareFullLogoProps> = ({
  className = "h-16 w-auto",
  alt = "Codii - AI Code Review Assistant"
}) => {
  const { theme } = useTheme();

  // Determine which logo to use based on theme
  const getLogoSrc = () => {
    if (theme === 'dark') {
      return CodiiLogoFullLight; // Use light logo on dark theme
    } else if (theme === 'light') {
      return CodiiLogoFullDark; // Use dark logo on light theme
    } else {
      // For system theme, check the actual applied theme
      const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
      return isDarkMode ? CodiiLogoFullLight : CodiiLogoFullDark;
    }
  };

  return (
    <img
      src={getLogoSrc()}
      className={className}
      alt={alt}
    />
  );
};

export default ThemeAwareFullLogo;
